const SectionTitle = () => import("@/components/SectionTitle/SectionTitle.vue");

import fallbackToAvatar from "@/mixins/fallbackToAvatar";
import Utils from "@/mixins/Utils";
import agencyService from '@/services/agency';
import { mapGetters } from "vuex";

export default {
  components: {
    SectionTitle,
  },
  mixins: [fallbackToAvatar, Utils],
  data() {
    return {
      ra: {}
    };
  },
  computed: {
    ...mapGetters({
      loading: 'isLoading',
      errorMessage: 'errorMessage'
    })
  },
  created() {
    this.loadRA();
  },
  methods: {
    loadRA() {
      const vue = this;
      agencyService.getAgence().then(res => {
        if (res.success && res.data && res.data.responsable) {
          vue.ra = res.data.responsable;
        }
      }).catch( err => {
        vue.callToaster(vue.$t('problem-arise'));
      })
    },
  },
};
